import {
	RideFiConfirmationLight as RideFiConfirmationLightBase,
	RideModal as RideModalBase,
	RideModalContent as RideModalContentBase,
} from '@rimac-seguros/ride-system-components';
import { useRef } from 'react';

const RideModal = RideModalBase as any;
const RideModalContent = RideModalContentBase as any;
const RideFiConfirmationLight = RideFiConfirmationLightBase as any;

type ModalConfirmacionProps = {
	isOpen?: boolean;
	onOpenChange?: (open: boolean) => void;
	onCloseButtonClick?: () => void;
	title?: string;
	message?: string;
	showMessageAsParagraph?: boolean;
};

export const ModalConfirmacion = ({
	isOpen,
	onOpenChange,
	onCloseButtonClick,
	title = '¡SOLICITUD ENVIADA CON ÉXITO!',
	message = '',
	showMessageAsParagraph = true,
}: ModalConfirmacionProps) => {
	const formRef = useRef<HTMLDivElement | null>(null);

	return (
		<RideModal
			isOpen={isOpen}
			size="small"
			onOpenChange={onOpenChange}
			onCloseButtonClick={onCloseButtonClick}
			initialFocusEl={() => formRef.current ?? document.body}
			finalFocusEl={() => document.body}
		>
			<RideModalContent>
				<div ref={formRef} tabIndex={-1}>
					<div className="flex justify-center">
						<RideFiConfirmationLight size="x-large" className="modal__icon" />
					</div>
					<h2
						style={{
							marginBottom: '20px',
							display: 'flex',
							justifyContent: 'center',
							marginTop: '20px',
						}}
					>
						{title}
					</h2>
					{showMessageAsParagraph ? (
						<p style={{ textAlign: 'center' }}>{message}</p>
					) : (
						<h2
							style={{
								marginBottom: '20px',
								display: 'flex',
								justifyContent: 'center',
								marginTop: '20px',
							}}
						>
							{message}
						</h2>
					)}
					<div style={{ marginBottom: '55px' }}></div>
				</div>
			</RideModalContent>
		</RideModal>
	);
};
